module.exports = __webpack_public_path__ + "img/工商业储能-液冷.6d66f6d6.png";